import React from "react";
import CommonIcon from "../helpers/icons";
import withRouter from "../custom/withRouter";
import { LastLogin } from "../../action/UsersApi";
import { connect } from "react-redux";
import API from "../helpers/endpointservice";
import { ReactComponent as LineProduct } from "../../assets/svg/Line 84 (1).svg";
import { ReactComponent as AppIcon } from "../../assets/svg/icon-park-outline_more-app.svg";

// ./components/helpers/endpointservice";
import axios from "axios";
import Actions from "../../action/api";
import {
  getParticularUser,
  updateUser,
  changePassword,
} from "../../action/UsersApi";
import {
  Backdrop,
  CircularProgress,
  Divider,
  Switch,
  TextField,
  withStyles,
} from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import toggleMenu from "../../redux/SideBar/sideBarActions";
class Homepage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isWebMobile: false,
      isLoading: false,
      applicationList: [],
    };
  }
  async componentDidMount() {
    this.getProductsList();
    let userid = JSON.parse(localStorage.getItem("UserInfoTAC")).userId;
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }
  getProductsList = () => {
    let data = {
      application: [],
      subcriptionStatus: "",
      sortBy: "",
      sortOrder: "",
      purchasedDate: null,
    };
    this.setState({ isLoading: true });
    Actions.POST(API.GetProductsList, data)
      .then((res) => {
        if (res.data) {
          this.setState({ applicationList: res.data });
        }
        this.setState({ isLoading: false });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        console.log(error);
      });
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 468) {
      this.setState({
        isMobile600: true,
        isWebMobile: true,
      });
    } else {
      this.setState({
        isMobile600: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 380) {
      this.setState({
        isMobile380: true,
      });
      this.setState({
        isMobile380: true,
      });
    } else {
      this.setState({
        isMobile380: false,
      });
    }
    this.setState({
      height: window.innerHeight,
    });
  };

  redirectToApp = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  render() {
    let { isWebMobile } = this.state;
    return !this.props.BG_LOADER && !this.state.isWebMobile ? (
      <div className="homepage">
        <Backdrop className="spinner-backdrop" open={this.state.isLoading}>
          <CircularProgress color="primary" />
        </Backdrop>
        <div className="row mt-3">
          <div className="col-12 pb-2">
            <CommonIcon fileName={"FlazlogoLogin"} />
          </div>
          {/* <div className='col-12'>
                        <div className='row'>
                            <h2 className='prod-header'>Our Products</h2>
                        </div>
                        <div className='col prod-top-para'>
                            <p> FLAZ offer a comprehensive suite of solutions designed to streamline and enhance your business operations.</p>
                        </div>
                    </div> */}
        </div>

        <div className="row mt-4">
          {this.state.applicationList &&
          this.state.applicationList.length > 0 ? (
            this.state.applicationList.map((data) => (
              <div
                key={data.id || data.name}
                className="col-12 col-md-6 col-lg-4 col-xl-4 cursor-pointer"
                id="list-products"
                onClick={() => {
                  this.redirectToApp(data.applicationUrl);
                }}
              >
                <div style={{ backgroundColor: "#fffefe" }}>
                  <LineProduct style={{ color: data.colorCode }} />
                </div>
                <div
                  className="prod-content w-100"
                  style={{
                    backgroundColor: "#fffefe",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  }}
                >
                  <div>
                    <CommonIcon fileName="Appmonitor" />
                  </div>
                  <h3 className="prod-title mt-2">{data.name}</h3>
                  <p className="prod-para">{data.description}</p>
                </div>
              </div>
            ))
          ) : !this.state.isLoading ? (
            <div
              className="d-flex align-items-stretch mt-3"
              style={{ width: "100%" }}
            >
              {/* Blue line */}
              <div style={{ backgroundColor: "#2196f3", width: "4px" }}></div>

              {/* White content box */}
              <div
                className="d-flex justify-content-center align-items-center text-center w-100"
                style={{
                  backgroundColor: "#fffefe",
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  minHeight: "120px", // Optional: keeps consistent height
                }}
              >
                <p
                  className="m-0"
                  style={{ fontSize: "18px", fontWeight: "bold" }}
                >
                  No products assigned
                </p>
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* <div
            class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 "
            id="list-products"
          >
            <div style={{ backgroundColor: "#fffefe" }}>
              <CommonIcon fileName={"LineProduct"} />
            </div>
            <div
              className="prod-content pt-2"
              style={{
                backgroundColor: "#fffefe",
                boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
              }}
            >
              <div>
                <CommonIcon fileName={"RMS"} />
              </div>
              <h3 className="prod-title">RMS</h3>
              <p className="prod-para">
                Flaz Recruitment Management System simplifies hiring with
                features for job postings, applicant tracking, and interview
                scheduling.
              </p>
            </div>
          </div> */}
          {/* <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 " id='list-products'>
                            <div className='' style={{ backgroundColor: '#fffefe' }}>
                                <CommonIcon fileName={'LineProduct'} />
                            </div>
                            <div className='prod-content pt-2' style={{ backgroundColor: '#fffefe', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                                <div>
                                    <CommonIcon fileName={'HRMS'} />
                                </div>
                                <h3 className='prod-title m--1'>HRMS</h3>
                                <p className='prod-para'>Flaz Human Resource Management System streamlines HR tasks like employee management, payroll, and performance tracking.</p>
                            </div>
                        </div> */}
          {/* <div
            class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 "
            id="list-products"
          >
            <div style={{ backgroundColor: "#fffefe" }}>
              <CommonIcon fileName={"LineProduct"} />
            </div>
            <div
              className="prod-content pt-2"
              style={{
                backgroundColor: "#fffefe",
                boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
              }}
            >
              <div>
                <CommonIcon fileName={"Appmonitor"} />
              </div>
              <h3 className="prod-title pt-2">App Monitor</h3>
              <p className="prod-para">
                Flaz App Monitor System tracks and analyzes application
                performance and health in real-time.
              </p>
            </div>
          </div> */}
          {/* <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 " id='list-products'>
                            <div style={{ backgroundColor: '#fffefe' }}>

                                <CommonIcon fileName={'LineProduct'} />

                            </div>
                            <div className='prod-content pt-2' style={{ backgroundColor: '#fffefe', position: 'relative', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                                <div style={{}}>
                                    <div>
                                        <CommonIcon fileName={'payroll'} />
                                    </div>
                                    <h3 className='prod-title pt-2'>Payroll System</h3>
                                    <p className='prod-para'>Flaz Payroll System automates salary calculations, tax deductions, and payment processing.</p>
                                    <a className='tnow'>Try Now <CommonIcon fileName={'SideArrow'} /></a>
                                    <div className='trybtn'>
                                        <button className='trybtn cursor-pointer'>Try Now</button>
                                    </div>

                                </div>
                            </div>
                        </div> */}
        </div>
      </div>
    ) : (
      <>
        <div className="row">
          <ToastContainer className="toast-container" />

          <div className="row mb-2">
            <div className="col-2">
              <span
                className="mobile-menuusers"
                onClick={() => this.props.toggleMenu()}
              >
                <CommonIcon fileName={"Menu"} />
              </span>
            </div>
            <div className="col-4 ps-0">
              <span className="headerform-mobile">
                {" "}
                <CommonIcon fileName={"FlazlogoLogin"} />
              </span>
            </div>
            <Backdrop
              className="spinner-backdrop"
              open={this.props.addUserIsLoader}
            >
              <CircularProgress color="primary" />
            </Backdrop>
            <div className="row mt-3"></div>

            <div className="row mt-4 homepageoverflow">
              {this.state.applicationList &&
              this.state.applicationList.length > 0 ? (
                this.state.applicationList.map((data) => (
                  <div
                    key={data.id || data.name}
                    className="col-12 col-md-6 col-lg-4 col-xl-4 cursor-pointer"
                    id="list-products"
                    onClick={() => {
                      this.redirectToApp(data.applicationUrl);
                    }}
                  >
                    <div style={{ backgroundColor: "#fffefe" }}>
                      <LineProduct style={{ color: data.colorCode }} />
                    </div>
                    <div
                      className="prod-content w-100"
                      style={{
                        backgroundColor: "#fffefe",
                        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                      }}
                    >
                      <div>
                        <CommonIcon fileName="Appmonitor" />
                      </div>
                      <h3 className="prod-title mt-2">{data.name}</h3>
                      <p className="prod-para">{data.description}</p>
                    </div>
                  </div>
                ))
              ) : !this.state.isLoading ? (
                <div
                  className="d-flex align-items-stretch mt-3"
                  style={{ width: "100%" }}
                >
                  {/* Blue line */}
                  <div
                    style={{ backgroundColor: "#2196f3", width: "4px" }}
                  ></div>

                  {/* White content box */}
                  <div
                    className="d-flex justify-content-center align-items-center text-center w-100"
                    style={{
                      backgroundColor: "#fffefe",
                      boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                      minHeight: "120px", // Optional: keeps consistent height
                    }}
                  >
                    <p
                      className="m-0"
                      style={{ fontSize: "18px", fontWeight: "bold" }}
                    >
                      No products assigned
                    </p>
                  </div>
                </div>
              ) : (
                <></>
              )}
              {/* <div
                class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 "
                id="list-products"
              >
                <div style={{ backgroundColor: "#fffefe" }}>
                  <CommonIcon fileName={"LineProduct"} />
                </div>
                <div
                  className="prod-content pt-2"
                  style={{
                    backgroundColor: "#fffefe",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  }}
                >
                  <div>
                    <CommonIcon fileName={"RMS"} />
                  </div>
                  <h3 className="prod-title">RMS</h3>
                  <p className="prod-para">
                    Flaz Recruitment Management System simplifies hiring with
                    features for job postings, applicant tracking, and interview
                    scheduling.
                  </p>
                </div>
              </div> */}
              {/* <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 " id='list-products'>
                                    <div className='' style={{ backgroundColor: '#fffefe' }}>
                                        <CommonIcon fileName={'LineProduct'} />
                                    </div>
                                    <div className='prod-content pt-2' style={{ backgroundColor: '#fffefe', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                                        <div>
                                            <CommonIcon fileName={'HRMS'} />
                                        </div>
                                        <h3 className='prod-title m--1'>HRMS</h3>
                                        <p className='prod-para'>Flaz Human Resource Management System streamlines HR tasks like employee management, payroll, and performance tracking.</p>
                                    </div>
                                </div> */}
              {/* <div
                class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 "
                id="list-products"
              >
                <div style={{ backgroundColor: "#fffefe" }}>
                  <CommonIcon fileName={"LineProduct"} />
                </div>
                <div
                  className="prod-content pt-2"
                  style={{
                    backgroundColor: "#fffefe",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  }}
                >
                  <div>
                    <CommonIcon fileName={"Appmonitor"} />
                  </div>
                  <h3 className="prod-title pt-2">App Monitor</h3>
                  <p className="prod-para">
                    Flaz App Monitor System tracks and analyzes application
                    performance and health in real-time.
                  </p>
                </div>
              </div> */}
              {/* <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 " id='list-products'>
                                    <div style={{ backgroundColor: '#fffefe' }}>

                                        <CommonIcon fileName={'LineProduct'} />

                                    </div>
                                    <div className='prod-content pt-2' style={{ backgroundColor: '#fffefe', position: 'relative', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                                        <div style={{}}>
                                            <div>
                                                <CommonIcon fileName={'payroll'} />
                                            </div>
                                            <h3 className='prod-title pt-2'>Payroll System</h3>
                                            <p className='prod-para'>Flaz Payroll System automates salary calculations, tax deductions, and payment processing.</p>
                                            <a className='tnow'>Try Now <CommonIcon fileName={'SideArrow'} /></a>
                                            <div className='trybtn'>
                                                <button className='trybtn cursor-pointer'>Try Now</button>
                                            </div>

                                        </div>
                                    </div>
                                </div> */}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(toggleMenu()) || false,
    dispatch,
  };
};
function mapStateToProps(state) {
  return {
    isLoading: state.commonReducer.isLoading,
    getParticularUser: state.userReducer.getParticularUser,
    addUserIsLoader: state.commonReducer.addUserIsLoader,
    BG_LOADER: state.userReducer.BG_LOADER,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Homepage)
);
